export default {
  publicAskings: [],
  pagination: {},
  publicAsking: {}
}
